module.exports = __webpack_public_path__ + "img/footer-icon-row-light-honda.e0b0bb85.png";